
import { eventBus } from '@Foundation/eventbus/eventbus';
import { throttle } from '@Foundation/utilities';

export const checkScreenSize = {
  data() {
    return {
      screenSize: 'small',
      smallScreenLimit: 768
    };
  },

  mounted() {
    this.getScreenSize();
  },

  methods: {
    widerThan768() {
      return window.matchMedia(`(min-width: ${this.smallScreenLimit}px)`).matches;
    },
    getScreenSize() {
      this.screenSize = window.matchMedia('(min-width: 1440px)').matches ? 'large' : this.widerThan768() && window.matchMedia('(max-width: 1024px)').matches ? 'tablet' : this.widerThan768() ? 'medium' : 'small';

      /* istanbul ignore next */
      eventBus.$on('mediaquery::changed', (mq) => {

        const resizeThrottler = throttle(() => {

          this.screenSize = window.matchMedia('(min-width: 1440px)').matches ? 'large' : this.widerThan768() && window.matchMedia('(max-width: 1024px)').matches ? 'tablet' : this.widerThan768() ? 'medium' : 'small';
        }, 160);

        if (mq.size === 'medium') {
          window.addEventListener('resize', resizeThrottler, false);
        } else {
          window.removeEventListener('resize', resizeThrottler, false);
          this.screenSize = mq.size;
        }
      });
    }
  }
};
